import { IRootState } from '@/store/state';
import { GetterTree, Getter } from 'vuex';
import { IUserState } from './state';
import { OrganisationUser, Role, PaginationMeta, UserFilter } from '../types';
import Organisation from '@/models/Organisation';

/**
 * --------------------------------------------------
 *	User Getters
 * --------------------------------------------------
 **/
export const UserGetters: IUserGetters = {
  organisationUsers: (state: IUserState): OrganisationUser[] =>
    state.organisationUsers,
  organisationClients: (state: IUserState): Organisation[] =>
    state.organisationClients,
  roles: (state: IUserState): Role[] => state.roles,
  userPaginationMeta: (state: IUserState): PaginationMeta =>
    state.userPaginationMeta,
  clientPaginationMeta: (state: IUserState): PaginationMeta =>
    state.clientPaginationMeta,
  appliedUserFilter: (state: IUserState): UserFilter => state.appliedFilter
};

/**
 * --------------------------------------------------
 *	User Getters Interface
 * --------------------------------------------------
 **/
export interface IUserGetters extends GetterTree<IUserState, IRootState> {
  organisationUsers(state: IUserState): OrganisationUser[];
  organisationClients(state: IUserState): Organisation[];
  roles(state: IUserState): Role[];
  userPaginationMeta(state: IUserState): PaginationMeta;
  clientPaginationMeta(state: IUserState): PaginationMeta;
  appliedUserFilter(state: IUserState): UserFilter;
}
